// eslint-disable-next-line no-shadow
export enum FooterLinks {
	MAC_OS_LINK = 'https://github.com/roverxio/affogato-desktop/releases/download/v1.14.9/Affogato-1.14.9-universal.dmg',
	TWITTER = 'https://x.com/ai_affogato',
	INSTAGRAM = 'https://www.instagram.com/ai.affogato/',
	YOUTUBE = 'https://www.youtube.com/@rendernet_ai',
	DISCORD = 'https://discord.com/invite/rendernet-ai',
	PRICING = 'https://app.affogato.ai/pricing',
	API_DOCUMENTATION = 'https://docs.rendernet.ai/api-reference/introduction',
	TIKTOK = 'https://www.tiktok.com/@affogato_ai',
}
